//@flow
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { ConstructionGalleryCard } from 'components/organisms/constructionGalleryCard';
import './styles.scss';
import { withRouter } from 'react-router-dom';
import ConstructionGalleryCardMobile from 'components/organisms/constructionGalleryCardMob';
import { useViewport } from 'components/templates/viewportProvider';

type Props = {
  data: Array,
};

const ConstructionGallerySection = (props: Props) => {
  const { data } = props;
  const { height } = useViewport();

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const title = () => {
    const {
      constructionGalleryIntro: { galleryHeadingMob, projectName },
    } = data.constructionGallery;
    return (
      <div className={'construction-gallery-mob-intro'}>
        <h3 className={'project-name'}>{projectName}</h3>
        <br /> <br />
        <h1>{galleryHeadingMob}</h1>
      </div>
    );
  };

  return (
    <div style={{ height }} id={'construction-gallery'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <ConstructionGalleryCard
            constructionGalleryData={data.constructionGallery}
            displayHeader={true}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <ConstructionGalleryCardMobile
          constructionGalleryData={data.constructionGallery}
          fetchTitle={title()}
        />
      )}
    </div>
  );
};
export default withRouter(ConstructionGallerySection);
